export default __webpack_public_path__ + "static/media/global-distribution.47ae7965.svg";